/* eslint-disable @typescript-eslint/no-explicit-any */
export enum ClientErrorCode {
  UNEXPECTED = 'UNEXPECTED',
  NETWORK_FAILURE = 'NETWORK_FAILURE',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  BAD_REQUEST = 'BAD_REQUEST',
  NO_PROJECT_ASSIGNED = 'NO_PROJECT_ASSIGNED',
  NOT_SUPPORTED_PROJECT = 'NOT_SUPPORTED_PROJECT',
  NO_JOB_ASSIGNED = 'NO_JOB_ASSIGNED',
  NO_JOBS_TO_ENQUEUE = 'NO_JOBS_TO_ENQUEUE',
  REVIEWER_ASSOCIATE_HAS_NO_JOBS = 'REVIEWER_ASSOCIATE_HAS_NO_JOBS',
  REVIEWER_ASSOCIATE_HAS_NO_RECENTLY_ANNOTATED_JOBS = 'REVIEWER_ASSOCIATE_HAS_NO_RECENTLY_ANNOTATED_JOBS',
  INVALID_NEXT_JOB_ID = 'INVALID_NEXT_JOB_ID',
  INVALID_PREV_JOB_ID = 'INVALID_PREV_JOB_ID',
  INVALID_FIRST_JOB_ID = 'INVALID_FIRST_JOB_ID',
  INVALID_LAST_JOB_ID = 'INVALID_LAST_JOB_ID',
  INVALID_JOB_ID = 'INVALID_JOB_ID',
  INVALID_PROJECT = 'INVALID_PROJECT',
  INVALID_JOB = 'INVALID_JOB',
  INVALID_CASE = 'INVALID_CASE',
  INVALID_IMAGE = 'INVALID_IMAGE',
  REPORTED_JOB = 'REPORTED_JOB',
  PAIR_JOB_NOT_MATCHED = 'PAIR_JOB_NOT_MATCHED',
  NO_GCS_IMAGES_SUPPORTED = 'NO_GCS_IMAGES_SUPPORTED',
}

const MESSAGES: Record<ClientErrorCode, string> = {
  [ClientErrorCode.UNEXPECTED]: 'Unexpected error happen.',
  [ClientErrorCode.NETWORK_FAILURE]:
    'Fail to reach server. Please check your network connection.',
  [ClientErrorCode.UNAUTHENTICATED]:
    'Your authentication seems expired. Please try login again.',
  [ClientErrorCode.UNAUTHORIZED]:
    'You are not allowed with this. Please contact your project manager.',
  [ClientErrorCode.NOT_SUPPORTED_PROJECT]:
    'This project is not supported. Please try with another project.',
  [ClientErrorCode.BAD_REQUEST]: 'Wrong request format.',
  [ClientErrorCode.NO_PROJECT_ASSIGNED]:
    'You do not have any project assigned. Please ask the administrator to assign some projects.',
  [ClientErrorCode.NO_JOB_ASSIGNED]:
    'There is no assigned job yet for current annotator in this project.',
  [ClientErrorCode.NO_JOBS_TO_ENQUEUE]: 'There is no more jobs to enqueue.',
  [ClientErrorCode.REVIEWER_ASSOCIATE_HAS_NO_JOBS]:
    'The selected annotator has no assigned jobs.',
  [ClientErrorCode.REVIEWER_ASSOCIATE_HAS_NO_RECENTLY_ANNOTATED_JOBS]:
    'The selected annotator has no recently annotated jobs. Please select a job from the job list.',
  [ClientErrorCode.INVALID_NEXT_JOB_ID]:
    'Failed to move to next. Please refresh it.',
  [ClientErrorCode.INVALID_PREV_JOB_ID]:
    'Failed to move to previous. Please refresh it.',
  [ClientErrorCode.INVALID_FIRST_JOB_ID]: 'Failed to move to the first job.',
  [ClientErrorCode.INVALID_LAST_JOB_ID]: 'Failed to move to the last job.',
  [ClientErrorCode.INVALID_JOB_ID]: 'Invalidated job id has give.',
  [ClientErrorCode.INVALID_PROJECT]: 'Failed to load the project.',
  [ClientErrorCode.INVALID_JOB]: 'Failed to load the job.',
  [ClientErrorCode.INVALID_CASE]: 'Failed to load the case.',
  [ClientErrorCode.INVALID_IMAGE]: 'Failed to load the image.',
  [ClientErrorCode.REPORTED_JOB]: 'This job has been reported.',
  [ClientErrorCode.PAIR_JOB_NOT_MATCHED]: 'There are incorrect pair job(s)',
  [ClientErrorCode.NO_GCS_IMAGES_SUPPORTED]:
    'This image server instance does not support GCS-based images',
} as const;

export const ClientErrorUtil = (() => {
  const getMessage = (code: ClientErrorCode): string =>
    MESSAGES[code] || MESSAGES[ClientErrorCode.UNEXPECTED];

  return Object.freeze({
    getMessage,
  });
})();

interface ConstructorParams {
  code: ClientErrorCode;
  originalError?: any;
  message?: string;
}

export class ClientError extends Error {
  public code: ClientErrorCode;
  public message: string;
  public originalError?: any;

  constructor({ code, message, originalError }: ConstructorParams) {
    super();
    this.code = code;
    this.message = message || ClientErrorUtil.getMessage(code);
    this.originalError = originalError;
    Object.setPrototypeOf(this, ClientError.prototype);
  }
}
